/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { AdvancedSearchHistoryListDto } from '../../models/advanced-search-history-list-dto';

export interface GetAdvancedSearchHistory$Params {}

export function getAdvancedSearchHistory(
  http: HttpClient,
  rootUrl: string,
  params?: GetAdvancedSearchHistory$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<AdvancedSearchHistoryListDto>> {
  const rb = new RequestBuilder(rootUrl, getAdvancedSearchHistory.PATH, 'get');
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AdvancedSearchHistoryListDto>;
      }),
    );
}

getAdvancedSearchHistory.PATH = '/me/advanced-search-history';
